import React, { useMemo } from 'react';
import { DataGrid, esES } from '@mui/x-data-grid';

const columns = [
  {
    field: 'num',
    width: 10,
    align: 'right',
    headerName: '#',
    disableColumnMenu: 100,
    hideable: false,
    sortable: false,
  },
  {
    field: 'DocSubDescription',
    width: 100,
    headerName: 'T.Doc Sun.',
    hideable: false,
    sortable: false,
  },
  { field: 'U_SYP_MDSD', width: 100, headerName: 'Serie Doc.', hideable: false, sortable: false },
  { field: 'U_SYP_MDCD', width: 100, headerName: 'Corr. Sun.', hideable: false, sortable: false },
  { field: 'TaxDate', width: 100, headerName: 'Fec. Doc.', hideable: false, sortable: false },
  { field: 'DocDueDate', width: 100, headerName: 'Fec. Vto.', hideable: false, sortable: false },
  {
    field: 'DocTotal',
    width: 150,
    align: 'right',
    headerName: 'Total Doc.',
    hideable: false,
    sortable: false,
  },
  {
    field: 'SumApplied',
    width: 150,
    align: 'right',
    headerName: 'Total Pagado.',
    hideable: false,
    sortable: false,
  },
];

function ShowDocument(props) {
  const documents = useMemo(() => {
    return props.documents.map((item, index) => {
      let DocSubDescription = item.DocSubDescription;
      if(DocSubDescription === undefined){
        if (item.U_SYP_MDTD === '07') {
          DocSubDescription = 'Nota crédito';
        }else{
          DocSubDescription = item.U_SYP_MDTD === '01' ? 'Factura' : item.U_SYP_MDTD === '03' ? 'Boleta' : item.U_SYP_MDTD === '08' ? 'Nota débito' : '';
        }
      }
      return { ...item, num: index + 1, DocSubDescription };
    });
  }, [props.documents]);

  return (
    <DataGrid
      localeText={esES.components.MuiDataGrid.defaultProps.localeText}
      columns={columns}
      rows={documents}
      disableSelectionOnClick
    />
  );
}

export default ShowDocument;
